import { render, staticRenderFns } from "./member-order-forbidden.component.vue?vue&type=template&id=7eac66c2"
import script from "./member-order-forbidden.component.vue?vue&type=script&lang=js"
export * from "./member-order-forbidden.component.vue?vue&type=script&lang=js"
import style0 from "./member-order-forbidden.component.vue?vue&type=style&index=0&id=7eac66c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports